"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const TimeFrame = ({
  currRange,
  onClick,
  ranges = ['1D', '1M', '3M', '6M', '1Y', 'All']
}) => (0, _pragma.createFelaElement)(_.View, {
  gap: "xsmall"
}, ranges.map(range => {
  const isCurrRange = range === currRange;
  return range && (0, _pragma.createFelaElement)(_.ButtonIcon, {
    disabled: isCurrRange,
    key: range,
    onClick: () => onClick(range),
    variant: "invisible"
  }, (0, _pragma.createFelaElement)(_.Text, {
    color: isCurrRange ? 'text.3' : 'text.1',
    size: "meta",
    weight: "bold"
  }, range));
}));

TimeFrame.displayName = 'TimeFrame';
var _default = TimeFrame;
exports.default = _default;
//# sourceMappingURL=TimeFrame.js.map